var React = require('react');

function AsteriskInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.87923 20L2.85024 18.3668L5.84541 14.0704L9.10628 10.804L4.75845 10.0503L0 8.41709L0.845411 5.90452L5.57971 7.53769L9.39614 9.77387L8.69565 5.42713V0H11.3043V5.42713L10.5797 9.77387L14.3961 7.53769L19.1546 5.90452L20 8.41709L15.2174 10.0503L10.8696 10.804L14.1546 14.0704L17.1498 18.3668L15.1208 20L12.0773 15.6533L10 11.407L7.9227 15.6533L4.87923 20Z","fill":"#8900FF"}));
}

AsteriskInline.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = AsteriskInline;

AsteriskInline.default = AsteriskInline;
